import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import { CustomTooltip } from "src/components/CustomTooltip";
import styles from "./Tooltip.module.css";
import { entityDefinition } from "@vzbl/integrations";
import { entityAttributeDefinition } from "@vzbl/integrations";
import { asKey } from "src/utils/fields";
import { formatAggregationFunction } from "src/utils/strings";

export const MeasureHeaderTooltipModule: TooltipContentModule = {
  type: "measure",
  priority: 2,
  shouldRender: (context: TooltipContext) => {
    return context.type === "measure" && !!context.metadata?.aggregation;
  },
  render: (context: TooltipContext) => {
    const { field, metadata } = context;
    const aggregation = metadata.aggregation;

    if (!field) return null;

    const entity = entityDefinition(field.target);
    const description = entityAttributeDefinition(asKey(field));
    const fieldKey = asKey(field);

    const content = (
      <div className={styles.tooltipContainer}>
        <div className={styles.tooltip_container}>
          <div className={styles.tooltip_header}>Measure Information</div>

          <div className={styles.tooltip_section}>
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Entity</div>
              <span className={styles.tooltip_value}>{field.target}</span>
            </div>
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Field</div>
              <span className={styles.tooltip_value}>{field.attribute}</span>
            </div>
            <div className={styles.tooltip_row}>
              <div className={styles.tooltip_label}>Operator</div>
              <span className={styles.tooltip_value}>
                {aggregation.reducer}
              </span>
            </div>
          </div>

          <div className={styles.tooltip_divider}></div>

          {entity?.description && (
            <div className={styles.tooltip_section}>
              <div className={styles.tooltip_row}>
                <div className={styles.tooltip_label}>Entity Description</div>
                <div className={styles.tooltip_description}>
                  {entity.description}
                </div>
              </div>
              <div className={styles.tooltip_row}>
                <div className={styles.tooltip_label}>Field Description</div>
                <div className={styles.tooltip_description}>{description}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );

    return (
      <CustomTooltip content={content} placement="bottom" size="medium">
        {context.children}
      </CustomTooltip>
    );
  },
};
